import { apiService } from './api';
import { PaginationParams } from '../types';

export interface SupplierDTO {
  id: number;
  code: string;
  name: string;
  contactEmail: string;
  contactPhone?: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  paymentTerms?: string;
  creditPeriodDays?: number;
  isActive: boolean;
  createdAt: string;
}

export interface CreateSupplierRequest {
  code: string;
  name: string;
  contactEmail: string;
  contactPhone?: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  paymentTerms?: string;
  creditPeriodDays?: number;
}

export interface UpdateSupplierRequest {
  code: string;
  name: string;
  contactEmail: string;
  contactPhone?: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  paymentTerms?: string;
  creditPeriodDays?: number;
  isActive: boolean;
}

const SUPPLIERS_API = '/suppliers';

export const supplierService = {
  getSuppliers: (params: PaginationParams) =>
    apiService.get<SupplierDTO[]>(SUPPLIERS_API, {
      pageNumber: params.pageNumber || 1,
      pageSize: params.pageSize || 50,
    }),

  getSupplierById: (id: string | number) =>
    apiService.get<SupplierDTO>(`${SUPPLIERS_API}/${id}`),

  getSupplierByCode: (code: string) =>
    apiService.get<SupplierDTO>(`${SUPPLIERS_API}/code/${code}`),

  checkSupplierCodeExists: async (code: string) => {
    try {
      await apiService.get<SupplierDTO>(`${SUPPLIERS_API}/code/${code}`);
      return { data: { data: { exists: true } } };
    } catch {
      return { data: { data: { exists: false } } };
    }
  },

  createSupplier: (data: CreateSupplierRequest) =>
    apiService.post<SupplierDTO>(SUPPLIERS_API, data),

  updateSupplier: (id: string | number, data: UpdateSupplierRequest) =>
    apiService.put<SupplierDTO>(`${SUPPLIERS_API}/${id}`, data),

  deleteSupplier: (id: string | number) =>
    apiService.delete<void>(`${SUPPLIERS_API}/${id}`),
};
